<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  
  <navbar-top></navbar-top>
  <sidebar-sx></sidebar-sx>
  
  <!-- Vista : Begin -->
  <div id="layoutSidenav_content">
    <main>
      <router-view/>
    </main>
  </div>
  <!-- Vista : End -->

</template>

<script>
import NavbarTop from "@/components/NavbarTop.vue";
import SidebarSx from "@/components/SidebarSx.vue";

export default {
  name: "App",
  components: { NavbarTop, SidebarSx },
  inject: ['cfg'],
  data: function() {
    return {
      
    }

  },
  mounted: function() {
   
  }

}

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

div.pol-container {
  text-align: left;;
  padding-top:0px;
  padding-left:10px;
  padding-right:10px;
  margin-left:240px;
}


/* riga seprazione sezioni dei form*/
div.rigaSezioneForm {
    margin-top: 30px;
    margin-bottom: 10px;
    border-bottom: solid 2px #909090;
    font-size: 1.3em;
}

/* testo evidenziato ovunque */
span.spn-evidenziato {
    background-color: lime;
}

div.divMiniBox {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: solid 1px #333;
  background-color: #fff;
}

/* TAbelline non griglia facile */
table.tblPoliDoc th {
    color: #fff;
    background-color: #009038;
    padding-left:10px;
    padding-right:10px;
    padding-top:5px;
    padding-bottom:5px;
}
table.tblPoliDoc thead {
    border-bottom:solid 2px #ccc;
}
table.tblPoliDoc tfoot tr {
    border-top:solid 2px #1f1f1f;
}



div.div-box-warning {
    border:solid #ddd 1px;
    border-radius: 10px;
    background-color: #ff6600;
    color: #fff;
    padding:3px 3px 3px 3px;
    text-align: center;
}

</style>
